define('Components/NewsWidget/js/NewsWidget',['hooks','Components/NewsWidget/js/views/NewsWidgetInstanceView','Components/NewsWidget/js/views/NewsColWidgetInstanceView','Components/NewsWidget/js/models/NewsWidgetInstanceModel','Components/NewsWidget/js/views/NewsListWidgetInstanceView'],
    function(hooks,NewsWidgetInstanceView,NewsColWidgetInstanceView,NewsWidgetInstanceModel,NewsListWidgetInstanceView){

    return function(){
        hooks.registerWidgetInstance(
            'NewsWidget',
            {
                'default': NewsWidgetInstanceView,
                '2-cols': NewsColWidgetInstanceView,
                'list': NewsListWidgetInstanceView
            },
            NewsWidgetInstanceModel
        );
    }

});
